import AdminReporting from './container';

export default AdminReporting;
